import { userRepository } from '../repositories/user-repository';

async function getUserGeo() {
    return userRepository.getGeo();
}

export {
    getUserGeo
};
